import { render, staticRenderFns } from "./ApprovedWorkingHoursPage.vue?vue&type=template&id=1556d2f0&"
import script from "./ApprovedWorkingHoursPage.vue?vue&type=script&lang=ts&"
export * from "./ApprovedWorkingHoursPage.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovedWorkingHoursPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VTab,VTabItem,VTabs})
